export const TransactionState = Object.freeze({
  Authorized: "Authorized",
  NotAuthorized: "Not Authorized",
  Confirmed: "Confirmed",
  NotConfirmed: "Not Confirmed",
  Verified: "Verified",
  NotVerified: "Not Verified",
  Voided: "Voided",
  NotVoided: "Not Voided",
  Reject: "Reject",
  Review: "Review",
});

export const WhatsappMessageType = Object.freeze({
  Session: "SESSION",
  ConversationStart: "START",
});
